import { addProp } from "@pnp/odata";
import { _Web } from "../webs/types.js";
import { Fields } from "./types.js";
addProp(_Web, "fields", Fields);
addProp(_Web, "availablefields", Fields, "availablefields");
//# sourceMappingURL=web.js.map